import { useState } from "react";
import { Pencil, Plus, Search } from "lucide-react";
import PageHero from "@/components/bakery/PageHero";
import { ShelfArt, ProductIcon } from "@/components/bakery/Art";
import ProductDialog from "@/components/master/ProductDialog";
import { Tag } from "@/components/common/Chips";
import { inputCls } from "@/components/common/Field";
import { Loading, PrimaryBtn } from "@/components/common/ui";
import { useApi } from "@/lib/useApi";
import { CATEGORY_ORDER } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function MasterProduk() {
  const { data, loading, reload } = useApi("/products");
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");
  const [edit, setEdit] = useState(undefined);
  const list = (data || []).filter((p) => (!cat || p.category === cat) && (!q || `${p.code} ${p.name}`.toLowerCase().includes(q.toLowerCase())));
  const pmap = Object.fromEntries((data || []).map((p) => [p.id, p]));
  return (
    <div data-testid="master-produk-page">
      <PageHero testid="produk-hero" eyebrow="Master" title="Produk" Art={ShelfArt} compact desc="Barang jadi saja — tidak ada bahan baku dan tidak ada harga."
        actions={<PrimaryBtn onClick={() => setEdit(null)} data-testid="add-product-btn"><Plus className="h-4 w-4" /> Tambah Produk</PrimaryBtn>} />
      <div className="mb-4 flex flex-col gap-3 sm:flex-row">
        <div className="relative sm:w-80"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari kode / nama" className={cn(inputCls, "pl-9")} data-testid="produk-search" /></div>
        <select value={cat} onChange={(e) => setCat(e.target.value)} className={cn(inputCls, "sm:w-56")} data-testid="produk-category-filter">
          <option value="">Semua kategori</option>{CATEGORY_ORDER.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>
      {loading && !data ? <Loading /> : (
        <div className="overflow-x-auto rounded-xl border border-zinc-200 bg-white">
          <table className="dense-table w-full min-w-[900px]" data-testid="produk-table">
            <thead><tr><th>Kode</th><th>Nama</th><th>Kategori</th><th>Satuan</th><th className="text-right">Pack Beli</th><th className="text-right">Pack Jual</th><th className="text-right">Min</th><th className="text-right">Stok</th><th>Status</th><th /></tr></thead>
            <tbody>{list.map((p) => (
              <tr key={p.id} data-testid={`produk-row-${p.code}`}>
                <td className="num font-semibold">{p.code}</td>
                <td><span className="flex items-center gap-2"><ProductIcon category={p.category} bundle={p.is_bundle} className="h-4 w-4" />{p.name}</span>
                  {p.is_bundle && <div className="text-[10px] text-zinc-500">Bundle: {p.bundle_components.map((c) => pmap[c]?.name).join(", ")}</div>}</td>
                <td>{p.category}</td><td>{p.stock_unit}</td><td className="num text-right">{p.purchase_pack_size}</td><td className="num text-right">{p.sales_pack_size}</td>
                <td className="num text-right">{p.min_stock}</td><td className={cn("num text-right font-bold", p.stock < 0 && "text-brand")}>{p.is_bundle ? "—" : p.stock}</td>
                <td>{p.active ? <Tag tone="soft">Aktif</Tag> : <Tag tone="red">Non-aktif</Tag>}</td>
                <td><button onClick={() => setEdit(p)} className="press grid h-8 w-8 place-items-center rounded border border-zinc-300 hover:border-ink" data-testid={`edit-product-${p.code}`}><Pencil className="h-3.5 w-3.5" /></button></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
      <ProductDialog open={edit !== undefined} product={edit} products={data} onClose={() => setEdit(undefined)} onSaved={() => { setEdit(undefined); reload(); }} />
    </div>
  );
}
